<template>
  <div>
    <!-- 上半部分 -->
    <div class="upbox">
      <div class="top">
        <div>
          <img
            src="@/assets/personal/work/back.png"
            class="top-left-img"
            @click="back"
          />
        </div>
        <div>
          <img src="@/assets/work/zhiwei.png" class="top-midlle-img" />
        </div>
        <div class="top-midlle-span">职位详情</div>
      </div>
      <div class="upb">
        <div class="upb-left">
          <img :src="info.user_avatar " alt="" />
          <div class="textbox">
            <span>{{ info.company.company_name	 }}</span>
            <p>{{ info.userapp.alias_name	 }}</p>
          </div>
        </div>
        <div class="upb-right">
          <el-row>
            <!--<el-button type="primary" @click="add">沟通</el-button>-->
          </el-row>
        </div>
      </div>
    </div>

    <!-- 横线 -->
    <div class="hline"></div>

    <!-- 下半部分 -->
    <div class="bottom">
      <div class="bottomLift">
        <p>入职进度</p>
        <div class="stepBar">
          <div class="block">
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in info.message"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
              >
                {{ activity.content }}
                <p>{{ activity.created_at }}</p>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <!-- 竖线 -->
      <div class="vline"></div>



      <div class="bottomRight">
        <!--0已报名，1面试邀请待处理，2淘汰，3备选，4已同意面试，5已拒绝面试，6已通过面试，7主管发送工作地址，8申请修改工作地址，9主管拒绝工作地址，10已同意工作地址，
          11已拒绝工作地址，12待签署合同，13拒绝签署合同，14已签署合同，15结算中，16结算完成-待评价，17代评价主管，18待评价企业，19已双评，20-->
            <p style="margin-bottom: 25px;text-align: right;width: 100%;">
            <el-button type="primary" @click="doInvite" v-if="info.relation_status==1">面试邀请</el-button>
            <el-button type="primary" @click="doAddress" v-if="info.relation_status==7">确认地址</el-button>
            <el-button type="primary" @click="doContract" v-if="info.relation_status==12">签署合同</el-button>
            <el-button type="primary" @click="evaluateManage" v-if="info.relation_status==16||info.relation_status==17">评价主管</el-button>
            <el-button type="primary" @click="evaluateCom" v-if="info.relation_status==16||info.relation_status==18">评价企业</el-button>

          </p>   
        <p style="margin-bottom: 25px">职位信息</p>
        <div class="testbox">
          <div>
            <span>职位</span>
            <p>{{ info.title	 }}</p>
          </div>
          <div>
            <span>薪资</span>
            <p>{{ info.wages	 }}</p>
          </div>
          <div>
            <span>工作时间</span>
            <p>{{ info.work_time }}</p>
          </div>
        </div>
        <div class="testbox">
          <span>起止时间</span>
          <p>{{ info.job_at }}</p>
        </div>
        <div class="testbox">
          <span>工作地址</span>
          <p v-if="info.relation_status>10">{{ info.j_address.adname }}</p>
          <p v-else v-for="(item,index) in info.address" :key="index">{{ item.adname }}</p>
        </div>
      </div>
    </div>
    <!-- <audition-dialog
      ref="auditionDialogRef"
    ></audition-dialog> -->
    <evaluation-dialog ref="auditionDialogRef"></evaluation-dialog>
    <invite-dialog ref="inviteDialogRef"></invite-dialog>
    <address-dialog ref="addressDialogRef"></address-dialog>
    <contract-dialog ref="contractDialogRef"></contract-dialog>
  </div>
</template>

<script>
// import auditionDialog from '@/views/personal/work/other/job/dialog/audition-dialog.vue';
// import addressDetailsDialog from '@/views/personal/work/other/job/dialog/addressDetails-dialog.vue';
import evaluationDialog from '@/views/personal/enroll/job/dialog/evaluation-dialog.vue';
import inviteDialog from '@/views/personal/enroll/job/dialog/invite-dialog.vue';
import addressDialog from '@/views/personal/enroll/job/dialog/address-dialog.vue';
import contractDialog from '@/views/personal/enroll/job/dialog/contract-dialog.vue';

import { jobEnrollInfo } from "@/api/personal/work/job/index.js";

export default {
  components: { 
    // auditionDialog,
    // addressDetailsDialog
    inviteDialog,
    addressDialog,
    contractDialog,
    evaluationDialog
   },
  data() {
    return {
      enroll_id:"",
      info:{
        userapp:{},
        company:{},
        information:{
          audit:{},
          j_address:{}
        }
      },
    
    };
  },
  mounted() {
    console.log(this.$route.query.id);
    if (this.$route.query.enroll_id != "") {
      this.enroll_id = this.$route.query.enroll_id;
      this.initData();
      // 获取接口
    }

  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  
    evaluateManage(){
      this.$refs.auditionDialogRef.init(this.info.enroll_id,17);
    },
    evaluateCom(){
      this.$refs.auditionDialogRef.init(this.info.enroll_id,18);
    },

    doInvite() {
      console.log(1111);
      this.$refs.inviteDialogRef.init(this.info.information.audit);
    },

    doAddress() {
      console.log(1111);
      var params=this.info.information.j_address;
      params.enroll_id=this.info.enroll_id;
      this.$refs.addressDialogRef.init(params);
    },

    doContract(){
      var params={
         contract_type: this.info.contract_type,
         contract_file: this.info.contract_file,
         contract_fname:  this.info.contract_fname,
         enroll_id:this.info.enroll_id
      }
      
      this.$refs.contractDialogRef.init(params);
    },

    
    

    initData() {
      jobEnrollInfo({ enroll_id: this.enroll_id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.info = res.data;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.upbox {
  margin-bottom: 26px;
}
.top {
  width: 950px;
  height: 31px;
  display: flex;
}
.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}
.top-midlle-img {
  width: 40px;
  height: 40px;
}
.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}
.top-right {
  margin-top: 2px;
  margin-left: 740px;
}
.upb {
  margin-top: 46px;
  margin-left: 25px;
  display: flex;
  justify-content: space-between;
}
.upb-left {
  display: flex;
}
.upb-left img {
  width: 36px;
  height: 36px;
  border-radius: 18px;
}
.textbox {
  margin-left: 14px;
  span {
    font-size: 11px;
    color: #000000;
  }
  p {
    font-size: 11px;
    color: #666666;
    margin-top: 10px;
  }
}
.hline {
  width: 1004px;
  height: 8px;
  background-color: #f8f8f8;
  margin-left: -27px;
  margin-right: -27px;
}
.bottomLift {
  margin-top: 23px;
}
.stepBar {
  height: 510px;
  margin-top: 21px;
}
// ::v-deep .el-timeline-item{
//   padding-bottom: 20px;
// }
.block {
  p {
    margin-top: 10px;
    font-size: 10px;
    color: #666666;
  }
  ::v-deep .is-bottom {
    font-size: 10px;
    color: #acacac;
  }
}
.bottom {
  height: 660px;
  display: flex;
  .bottomLift {
    width: 256px;
    min-width: 256px;
    max-width: 256px;
  }
  .vline {
    width: 8px;
    height: 687px;
    background-color: #f8f8f8;
  }
}
.bottomRight {
  margin-top: 25px;
  width: 662px;
  margin-left: 24px;
  .testbox {
    margin-bottom: 25px;
    div {
      margin-right: 95px;
    }
    span {
      font-size: 11px;
      color: #acacac;
    }
    p {
      font-size: 11px;
      font-weight: bold;
      color: #181818;
      margin-top: 12px;
    }
    div:nth-child(3) {
      margin-right: 0;
    }
  }
}
.testbox:nth-child(2) {
  display: flex;
}
</style>